import { Container, Divider } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  DatePicker,
  FormLabel,
  ModalError,
  ModalSuccess,
  NumberInput,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  SwitchInput,
} from "components";
import { HeaderTitle } from "layouts";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatPayloadDate, getErrors } from "utils";

const InvoiceConf = () => {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [payload, setPayload] = useState({
    period: 0,
    start_date: null,
    end_date: null,
    is_active_flag: false,
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangePeriod = event => {
    const value = Number(event);
    setPayload(prev => ({
      ...prev,
      period: value,
      start_date: moment().subtract(value, "months"),
      end_date: moment().subtract(1, "months"),
    }));
  };

  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/configuration/invoice`,
        { headers }
      );
      const { is_active_flag, period, start_date, end_date } = res?.data?.data;
      const preload = {
        is_active_flag,
        period,
        start_date: moment(start_date),
        end_date: moment(end_date),
      };
      setPayload(preload);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const { end_date, start_date, ...restPayload } = payload;
    try {
      setLoadingPage(true);
      await axios.post(
        `${hardBaseUrl}/publisher/configuration/invoice`,
        {
          ...restPayload,
          start_date: formatPayloadDate(start_date),
          end_date: formatPayloadDate(end_date),
        },
        { headers }
      );
      ModalSuccess("Succesfully save Invoice Configuration").then(() =>
        getDetail()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <Page className={classes.root} title="Invoice">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <SectionLabel
          title="Invoice"
          subTitle="This feature is to active/deactivate invoice claims which can be done automatically"
          my="16px"
        />
        <Box border="1px solid #ebebeb" borderRadius="5px" p="24px">
          {loadingPage ? (
            <SkeletonComponent variant="wave" />
          ) : (
            <Grid container columnSpacing={2} rowSpacing={1}>
              <Grid item xs={12}>
                <SwitchInput
                  checked={payload?.is_active_flag}
                  onChange={e =>
                    handleChangePayload(e?.target?.checked, "is_active_flag")
                  }
                  label="Automatically Invoice"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="Period" required />
                <NumberInput
                  value={payload?.period}
                  onChange={handleChangePeriod}
                  endAdornment="Months"
                />
              </Grid>
              <Grid item xs={0} md={6} />
              <Grid item xs={12} md={6}>
                <FormLabel label="Start Date" required />
                <DatePicker value={payload?.start_date} disabled />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel label="End Date" required />
                <DatePicker value={payload?.end_date} disabled />
              </Grid>
            </Grid>
          )}
        </Box>
        <Grid container justifyContent="right" mt="16px">
          <PrimaryButton label="Save" onClick={handleSubmit} />
        </Grid>
      </Container>
    </Page>
  );
};

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/invoice",
  },
  {
    label: "Invoice",
    active: true,
  },
];

export default InvoiceConf;
